import { initializeApp } from "firebase/app"
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC1wY2r4_8AVCqlDQxsn5m_4WEi7GbLQ9g",
  authDomain: "stefania-9d521.firebaseapp.com",
  projectId: "stefania-9d521",
  storageBucket: "stefania-9d521.appspot.com",
  messagingSenderId: "1082109075164",
  appId: "1:1082109075164:web:f6c55d0c873b5842f61e19"
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app